<section class="py-10">
  <div class="promotion-container">
    <div class="promotion">
      <div class="promotion-content">
        <div class="content">
          <h2 class="text-2xl">
            {{ title }}
          </h2>
          <p class="text">
            {{ description }}
          </p>
          <app-button [text]="textCta" [href]="hrefCta"></app-button>
        </div>
        <img
          class="image max-w-[408px] max-h-[620px] absolute bottom-0 right-[70px] hidden lg:block"
          [src]="img ? img : 'assets/img/mulher-com-maquina-1.png'"
          alt=""
        />
      </div>
    </div>
    <img
      class="bg-desktop w-full hidden lg:block absolute bottom-0 left-0 z-[-1]"
      src="assets/img/banners/bg-loja-de-roupas.png"
      alt=""
    />
    <img
      class="bg-mobile lg:hidden"
      [src]="imgMobile ? imgMobile : 'assets/img/banners/bg-mulher-maquina-na-mao.png'"
      alt=""
    />
  </div>
</section>
